import React from "react";
import { I18n } from "../../../../i18n/i18n";
import { Subtitle } from "../../../../model/playerConfiguration/Subtitle";
import { SubtitlesSelectedIconComponent } from "../../../icons/subtitles/SubtitlesSelectedIconComponent";
import { ToggleComponent } from "./ToggleComponent";

import "@styles/c-subtitleSelector.scss";

interface Props {
  i18n: I18n;
  subtitles: Subtitle[];
  selectedSubtitlesSrc?: string;
  onSubtitleSourceSelected: (subtitle?: Subtitle) => void;
 
}

interface State {}

export class SubtitleSelectorComponent extends React.Component<Props, State> {

  render() {
    const { i18n, subtitles, selectedSubtitlesSrc, onSubtitleSourceSelected } = this.props;

    return (
      <div
        className="c-subtitleSelector"
        onClick={(event) => event.nativeEvent.stopImmediatePropagation()}
      >
        <label className="c-subtitleSelector__switch">
          <span className="c-subtitleSelector__switchLabel">
            {i18n.subtitles}
          </span>
          <ToggleComponent
            checked={!!selectedSubtitlesSrc}
            onChange={() => this.toggleSubtitles()}
          />
        </label> 
        {subtitles.length > 0 &&
          <ul className="c-subtitleSelector__list">
            {subtitles.map((subtitle) => (
              <li 
                className="c-subtitleSelector__item"
                key={subtitle.source}
              >
                <button
                  className={`c-subtitleSelector__button ${subtitle.source === selectedSubtitlesSrc ?
                     "c-subtitleSelector__button--active" : ""}`}
                  onClick={() => onSubtitleSourceSelected(subtitle)}>
                  {subtitle.label}
                  {subtitle.source === selectedSubtitlesSrc &&
                    <>
                      <span className="c-subtitleSelector__buttonSpacer" />
                      <SubtitlesSelectedIconComponent />
                    </>
                  }
                </button>
              </li>
            ))}
          </ul>
        }
      </div>
    );
  }

  toggleSubtitles() {
    const { selectedSubtitlesSrc, subtitles, onSubtitleSourceSelected } = this.props;
    if (selectedSubtitlesSrc) {
      onSubtitleSourceSelected(undefined);
    } else {
      onSubtitleSourceSelected(subtitles[0]);
    }
  }

}
